import { createElement } from 'react';
import './index.scss';
import { Rating as NextRating } from '@alifd/next';
const Rating = ({ dataList, value, size, disabled, onClick, children, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "rating", ..._otherProps, onClick: onClick },
        createElement(NextRating, { disabled: disabled, value: value, size: size })));
};
Rating.displayName = 'Rating';
export default Rating;
